<template lang="pug">
  .component-create-entity-button
    .row.column

    .card
      .inner-content
        h2 Federation configuration
        template
          accordion
            accordion-item(title="Document types")
              .row
                .column
                  SelectizeDocumentType(v-model="documentType", value-field="id" )
                .column
                  ActionButton(:action="addDocumentType") Add
              BaseList(:component="component", :dataLoader="dataLoader")
    .card
      .inner-content
        h2 Global configuration overrides
        accordion
          accordion-item(v-for="(section, i) in conf", :title="i")
            configuration-item(v-for="(c, ic) in section", :item="c", :itemKey="ic", @updateItem="updateItem", @deleteItem="deleteItem", :override="true")
</template>
<script type="text/babel">

import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import Accordion from 'components/structure/foundation/Accordion/Accordion'
import AccordionItem from 'components/structure/foundation/Accordion/AccordionItem'
import ConfigurationItem from "../../components/backoffice/ConfigurationItem.vue";
import MaggieHelper from "../../maggieHelper";
import SelectizeDocumentType from "../../components/structure/ui/lists/selectize/SelectizeDocumentType.vue";
import ActionButton from "../../components/structure/ui/ActionButton.vue";
import DocumentType from "../../components/backoffice/DocumentType.vue";
import DocumentTypeFederation from "../../components/backoffice/DocumentTypeFederation.vue";
import BaseList from "./BaseList.vue";
import {EventBus} from "../../eventBus";

export default {
  name: 'FederationConfigEdit',
  components: {
    BaseList,
    DocumentTypeFederation,
    DocumentType,
    ActionButton,
    SelectizeDocumentType,
    ConfigurationItem,
    AccordionItem,
    Accordion,
  },
  data() {
    return {
      conf: null,
      documentType: null,
      component: require("components/backoffice/DocumentTypeFederation.vue")
    }
  },

  created() {
    this.loadConfiguration()
  },
  methods: {
    loadConfiguration() {
      this.conf = null
      KeplerBackofficeSdk.federationConfig.select(this.$route.params.id).get((data) => {
        this.conf = data
      })
    },
    updateItem(key, value) {
      KeplerBackofficeSdk.federationConfig.select(this.$route.params.id).update({key, value}, () => {
        MaggieHelper.notification('Updated', 'Override updated', 'success')
        this.loadConfiguration()
      })
    },
    deleteItem(key) {
      KeplerBackofficeSdk.federationConfig.select(this.$route.params.id).delete({key}, () => {
        MaggieHelper.notification('Updated', 'Override deleted', 'success')
        this.loadConfiguration()
      })
    },
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.federationEntities.list(page, resultsPerPage).all(this.$route.params.id, (data) => (
        callback(data)
      ))
    },
    addDocumentType() {
      return KeplerBackofficeSdk.federationEntities.make(this.$route.params.id, {
        "entity_type": "App\\Models\\DocumentType",
        "entity_id": this.documentType
      }, () => {
        EventBus.$emit('reload-list')
      })

    }
  },
  props: ['item']
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// FederationConfigEdit.vue?028c1946